module.exports = __webpack_public_path__ + "static/media/font-logo-stg2.ad0d8d81.svg";